import { PriceListFilterInput } from "@/gql/graphql";
import { PriceListFilterStateType } from "../components/price-list-filter/PriceListFilterContext";

const selection = <T>(values: T[]): T[] | undefined =>
  values.length > 0 ? values : undefined;

export type PriceListFilterValidation =
  | { valid: true; input: PriceListFilterInput }
  | { valid: false; missing: string[] };

export const validatePriceListFilter = (
  filterState: PriceListFilterStateType
): PriceListFilterValidation => {
  const { from: lengthFrom, to: lengthTo } = filterState.lengthRange;
  const { currency, date, selectedRoutes } = filterState;

  const missing: string[] = [];
  if (!currency) {
    missing.push("Currency");
  }
  if (selectedRoutes.length === 0) {
    missing.push("Routes");
  }
  if (lengthFrom == null) {
    missing.push("Length from");
  }
  if (lengthTo == null) {
    missing.push("Length to");
  }
  if (!date) {
    missing.push("Date");
  }

  if (
    !currency ||
    selectedRoutes.length === 0 ||
    lengthFrom == null ||
    lengthTo == null ||
    !date
  ) {
    return { valid: false, missing };
  }

  return {
    valid: true,
    input: {
      conversionCurrency: currency,
      customerNumbers: selection(
        filterState.selectedCustomers
          .map((customer) => Number(customer.value))
          .filter((customerNumber) => Number.isFinite(customerNumber))
      ),
      sailingCategories: selection(filterState.selectedSailingCategories),
      routes: selectedRoutes.map((route) => route.value),
      vehicleTypes: filterState.vehicleTypeAll
        ? undefined
        : selection(filterState.selectedVehicleTypes.map((vt) => vt.code)),
      lengthFrom,
      lengthTo,
      date,
    },
  };
};
